// src/components/ListView/campaign/index.js

import React, { useRef } from 'react'
import {
  ListItem,
  withStyles,
  Grid,
  ListItemSecondaryAction,
  // MenuItem,
} from '@material-ui/core'
import Menu from '../Menu'
import language from 'utils/vast-languagepack'
import {
  Done,
  SettingsInputAntenna,
  Loop,
  Pause,
  People,
  Email,
  Sms,
} from '@material-ui/icons'
import classNames from 'classnames'
import { startCase } from 'lodash'
import { stepperGoTo, forceListUpdate } from 'actions/view'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import Ellipsis from 'components/theme/Ellipsis'
import { updateStatus } from 'actions/campaign/addOrEdit'
import { read } from 'actions/data'

const IconMap = {
  W: style => <Loop style={style ? style : {}} />,
  P: style => <Pause style={style ? style : {}} />,
  L: style => <SettingsInputAntenna style={style ? style : {}} />,
  C: style => <Done style={style ? style : {}} />,
}

export const FunnelStatComponent = withStyles(theme => ({
  stage: {
    borderRadius: 20,
    height: 25,
    margin: '0 auto',
    color: '#fff',
  },
  stageStatsPage: {
    borderRadius: 20,
    height: 35,
    margin: '0 auto',
    color: '#fff',
  },
  stage0: {
    backgroundColor: theme.palette.secondary.main,
    width: '100%',
  },
  stage1: {
    backgroundColor: theme.palette.pink,
    width: '90%',
  },
  stage2: {
    backgroundColor: theme.palette.orange,
    width: '80%',
  },
  stage3: {
    backgroundColor: theme.palette.green,
    width: '70%',
  },
  stageMore: {
    backgroundColor: theme.palette.green,
    width: '70%',
  },
}))(({ classes, campaign, statsPage }) => {
  const currentContactCount = useRef(null)

  return (
    <div style={{ position: 'relative', textAlign: 'center' }}>
      {campaign?.stages?.map((stage, idx) => (
        <div
          key={`list-campaign${campaign.id}-stage${stage.id}`}
          style={{ padding: '0 9px', whiteSpace: 'nowrap' }}
          className={classNames(
            statsPage ? classes.stageStatsPage : classes.stage,
            // classes.stageMore,
            classes[`stage${idx}`] || classes.stageMore,
          )}
        >
          <div
            style={{
              display: 'inline-block',
              // maxWidth: `calc(100% - ${
              // 	currentContactCount?.current?.offsetWidth || 0
              // }px)`,
              maxWidth: 'calc(100% - 29px)',
              verticalAlign: 'sub',
            }}
          >
            <Ellipsis>
              {stage.name} - {stage.current_contact_count}
            </Ellipsis>
            {/* {stage.name} */}
          </div>
          <div ref={currentContactCount} style={{ display: 'inline-block' }}>
            <People
              style={{
                color: '#fff',
                verticalAlign: 'middle',
                marginLeft: 5,
              }}
            />
          </div>
        </div>
      ))}
      {campaign?.stages?.length > 5 && (
        <div
          style={{
            position: 'absolute',
            height: '100%',
            width: '100%',
            top: 0,
            left: 0,
            background: 'linear-gradient(rgba(255,255,255,0), #fff)',
          }}
        />
      )}
    </div>
  )
})

const CampaignListItem = withStyles(theme => ({
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: 'bold',
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
    marginBottom: 5,
  },
  description: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(15),
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
    marginBottom: 5,
  },
  createdHeading: {
    color: theme.palette.text.secondary,
    fontSize: theme.typography.pxToRem(12),
    fontWeight: 'bold',
    display: 'table',
    tableLayout: 'fixed',
    width: '100%',
    whiteSpace: 'nowrap',
    [theme.breakpoints.down('xs')]: {
      fontSize: theme.typography.pxToRem(11),
    },
  },
  text: {
    display: 'table-cell',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  createdDate: {
    color: theme.palette.secondary.main,
    display: 'inline-block',
  },
  secondaryAction: {
    paddingLeft: 80,
    minHeight: 120,
    position: 'relative',
    [theme.breakpoints.up('xs')]: {
      paddingRight: 33,
    },
    [theme.breakpoints.up('md')]: {
      paddingRight: 60,
    },
  },
  container: {
    listStyle: 'none',
    borderBottom: '1px solid #adadad',
    borderRight: '1px solid #adadad',
  },
  secondaryActionRoot: {
    [theme.breakpoints.up('xs')]: {
      top: 'calc(50% - 16px)',
    },
    [theme.breakpoints.up('md')]: {
      top: 'calc(50% - 24px)',
    },
  },
  info: {
    display: 'inline-block',
  },
  statSection: {
    textAlign: 'left',
    display: 'inline-block',
    marginLeft: 10,
    [theme.breakpoints.down('sm')]: {
      marginLeft: 0,
    },
    // '&last-child': {
    //   marginLeft: 0,
    // },
  },
  statBlock: {
    width: 225,
    // maxHeight: 135,
    borderRadius: 25,
    border: '1px solid #ccc',
    padding: '5px 5px 5px 10px',
    overflowX: 'hidden',
    position: 'relative',
  },
  funnelStatBlock: {
    '&:hover': {
      backgroundColor: '#0000004d',
    },
  },
  stage: {
    borderRadius: 20,
    height: 25,
    margin: '0 auto',
    color: '#fff',
  },
  stage0: {
    backgroundColor: theme.palette.secondary.main,
    width: '100%',
  },
  stage1: {
    backgroundColor: theme.palette.pink,
    width: '90%',
  },
  stage2: {
    backgroundColor: theme.palette.orange,
    width: '80%',
  },
  stage3: {
    backgroundColor: theme.palette.green,
    width: '70%',
  },
  stageMore: {
    backgroundColor: theme.palette.green,
    width: '70%',
  },
}))(
  ({
    classes,
    addOrEditPush,
    campaign,
    size,
    entityType,
    stepperGoTo,
    updateStatus,
    connectedStatus,
    read,
    forceListUpdate,
    isPinned,
  }) => {
    // const [campaignStatus, setCampaignStatus] = useState(null)
    const date = new Date(campaign.when_created)
    const startDate = campaign.start_date && new Date(campaign.start_date)
    const endDate = campaign.end_date && new Date(campaign.end_date)

    const statusObj = {
      W: 'Work in Progress',
      L: 'Live',
      P: 'Paused',
      C: 'Complete',
    }
    const colorObj = {
      W: '#930766',
      C: '#014c94',
      L: '#15b940',
      P: '#d89300',
    }

    let totalNumberOfStats = 0
    if (campaign.stats) {
      if (campaign.stats.email) {
        totalNumberOfStats += Object.keys(campaign.stats.email).length
      }
      if (campaign.stats.sms) {
        totalNumberOfStats += Object.keys(campaign.stats.sms).length
      }
    }

    const TaskStats = (
      <div className={classes.statSection}>
        <div className={classes.statBlock}>
          <Grid container>
            {campaign?.stats?.sms
              ? Object.keys(campaign.stats.sms).map(stat => (
                  <Grid
                    item
                    xs={12}
                    // sm={12}
                    // md={totalNumberOfStats > 6 ? 6 : 12}
                  >
                    <Sms
                      style={{
                        marginRight: 5,
                        color: '#ccc',
                        verticalAlign: 'middle',
                      }}
                    />
                    <span style={{ fontWeight: 500 }}>{`${startCase(
                      `${stat?.split?.('_')?.[0]} text ${
                        stat?.split?.('_')?.[1]
                      }` || stat,
                    )}: `}</span>
                    {campaign.stats.sms[stat]}
                  </Grid>
                ))
              : null}
            {campaign?.stats?.email
              ? Object.keys(campaign.stats.email).map(stat => (
                  <Grid
                    item
                    xs={12}
                    // sm={12}
                    // md={totalNumberOfStats > 6 ? 6 : 12}
                  >
                    <Email
                      style={{
                        marginRight: 5,
                        color: '#ccc',
                        verticalAlign: 'middle',
                      }}
                    />
                    <span style={{ fontWeight: 500 }}>{`${startCase(
                      startCase(
                        `${stat?.split?.('_')?.[0]} email ${
                          stat?.split?.('_')?.[1]
                        }` || stat,
                      ),
                    )}: `}</span>
                    {campaign.stats.email[stat]}
                  </Grid>
                ))
              : null}
          </Grid>
        </div>
      </div>
    )

    const FunnelStats = (
      <div
        className={classes.statSection}
        onClick={e => {
          e.stopPropagation()
          stepperGoTo(1, 'campaign')
          addOrEditPush(campaign.id)
        }}
      >
        <div className={classNames(classes.statBlock, classes.funnelStatBlock)}>
          <FunnelStatComponent campaign={campaign} />
        </div>
      </div>
    )

    // const status = campaignStatus || campaign.status
    const status = connectedStatus

    return (
      <ListItem
        onClick={() => {
          if (campaign.stats) {
            stepperGoTo(3, 'campaign')
          } else {
            stepperGoTo(1, 'campaign')
          }
          addOrEditPush(campaign.id)
        }}
        key={`campaignsPageListItem${campaign.id}`}
        button
        classes={{
          container: classes.container,
          secondaryAction: classes.secondaryAction,
        }}
      >
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translate(0, -50%)',
            textAlign: 'center',
            width: 80,
            color: colorObj[status],
            fontSize: 11,
            fontWeight: 'bold',
          }}
        >
          <div
            style={{
              width: '60px',
              height: '60px',
              borderRadius: '50%',
              backgroundColor: colorObj[status],
              margin: 'auto',
              color: '#fff',
            }}
          >
            {IconMap[status]({ marginTop: 17 })}
          </div>
          <div>{statusObj[status]}</div>
        </div>
        <Grid container className={classes.info}>
          <Grid item xs={12}>
            <div className={classes.heading}>
              <span className={classes.text}>{isPinned ? '📌 ' : ''}{campaign.name}</span>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.description}>
              <span className={classes.text}>{campaign.description}</span>
            </div>
          </Grid>
          <Grid item xs={12}>
            <div className={classes.createdHeading}>
              <span className={classes.text}>
                <em>
                  <span>
                    <span>{`${language.task.menuSort.created} `}</span>
                    <span className={classes.createdDate}>
                      {`${date.toLocaleDateString()}`}
                    </span>
                  </span>
                </em>
              </span>
            </div>
          </Grid>
          {startDate && (
            <Grid item xs={12}>
              <div className={classes.createdHeading}>
                <span className={classes.text}>
                  <em>
                    <span>
                      <span>{`Start date: `}</span>
                      <span className={classes.createdDate}>
                        {`${startDate.toLocaleDateString()}`}
                      </span>
                    </span>
                  </em>
                </span>
              </div>
            </Grid>
          )}
          {endDate && (
            <Grid item xs={12}>
              <div className={classes.createdHeading}>
                <span className={classes.text}>
                  <em>
                    <span>
                      <span>{`End date: `}</span>
                      <span className={classes.createdDate}>
                        {`${endDate.toLocaleDateString()}`}
                      </span>
                    </span>
                  </em>
                </span>
              </div>
            </Grid>
          )}
          {size === 'small' && status !== 'W' && (
            <>
              {totalNumberOfStats ? (
                <Grid item xs={12}>
                  {TaskStats}
                </Grid>
              ) : null}
              {campaign?.stages?.length ? (
                <Grid item xs={12}>
                  {FunnelStats}
                </Grid>
              ) : null}
            </>
          )}
        </Grid>
        {size === 'large' && status !== 'W' && (
          <>
            {totalNumberOfStats ? TaskStats : null}
            {campaign?.stages?.length ? FunnelStats : null}
          </>
        )}
        <ListItemSecondaryAction
        // classes={{ root: classes.secondaryActionRoot }}
        >
          <Menu
            vert
            entityName={campaign.name}
            entityType={entityType}
            entityID={campaign.id}
            addOrEditPush={addOrEditPush}
            campaignMenuItemContent={
              <>
                {status === 'W' || status === 'P' ? (
                  <>
                    {IconMap.L({ marginRight: 8, fill: 'rgba(0, 0, 0, 0.54)' })}
                    Go Live
                  </>
                ) : null}
                {status === 'L' ? (
                  <>
                    {IconMap.P({ marginRight: 8, fill: 'rgba(0, 0, 0, 0.54)' })}
                    Pause
                  </>
                ) : null}
              </>
            }
            updateStatus={() => {
              // const prevStatus = status
              // const prevToNextStatusMap = { W: 'L', L: 'P', P: 'L' }

              updateStatus(status, campaign.id).then(() =>
                read(campaign.id, 'campaign'),
              )
              .then(() => forceListUpdate())
              // .then(() => toggleListViewHidden())
              // .then(() => setTimeout(() => toggleListViewHidden(), 1000))
            }}
          />
        </ListItemSecondaryAction>
      </ListItem>
    )
  },
)

export default connect(
  (state, { campaign }) => ({
    connectedStatus: state.data?.campaign?.[campaign?.id]?.status,
  }),
  dispatch =>
    bindActionCreators(
      { stepperGoTo, updateStatus, read, forceListUpdate },
      dispatch,
    ),
)(CampaignListItem)
